import { apiUrl } from '../../../config/api';
async function parseResponse(response) {
    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    const payload = await response.json();

    if (typeof payload === 'string') {
        try {
            return JSON.parse(payload);
        } catch (error) {
            return payload;
        }
    }

    return payload;
}

// Module-level cache for jugador profiles to avoid re-fetching on remount
const jugadorCache = new Map(); // Maps nombreJugador -> parsed data
let jugadorCachePromises = new Map(); // Maps nombreJugador -> fetch promise (for deduplication)

async function loadJugadorData(nombreJugador) {
    // Return from cache if available
    if (jugadorCache.has(nombreJugador)) {
        return jugadorCache.get(nombreJugador);
    }

    // Return existing fetch promise if already in flight (deduplication)
    if (jugadorCachePromises.has(nombreJugador)) {
        return jugadorCachePromises.get(nombreJugador);
    }

    // Start new fetch and track it
    const fetchPromise = (async () => {
        const response = await fetch(apiUrl('perfil/') + nombreJugador);
        const dataParsed = await parseResponse(response);

        const careerHighs = dataParsed.jugador?.[0]?.careerHighs || {};

        const result = {
            data: dataParsed.jugador,
            maximos: {
                puntos: careerHighs.puntos || null,
                asistencias: careerHighs.asistencias || null,
                rebotes: careerHighs.rebotes || null,
                robos: careerHighs.robos || null,
                tapas: careerHighs.tapas || null,
                dobles: careerHighs.doblesHechos || null,
                triples: careerHighs.triplesHechos || null,
                libres: careerHighs.libresHechos || null,
            },
            ultimosCinco: dataParsed.ultimosCinco,
            posicionesRecords: dataParsed.posicionesRecords,
            posicionesMaximos: dataParsed.posicionesMaximos,
        };

        // Cache successful result
        jugadorCache.set(nombreJugador, result);
        return result;
    })();

    jugadorCachePromises.set(nombreJugador, fetchPromise);

    try {
        return await fetchPromise;
    } finally {
        jugadorCachePromises.delete(nombreJugador);
    }
}

export async function fetchJugadorData(nombreJugador) {
    return loadJugadorData(nombreJugador);
}

export async function fetchJugadorGamelog(jugador, liga) {
    const response = await fetch(apiUrl('gamelog/') + jugador + '/' + liga, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });

    return parseResponse(response);
}
